var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlans({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 5.4L13.3001 1.5C13.1001 1.2 12.8001 1 12.4001 1H3.60013C3.20013 1 2.90013 1.2 2.70013 1.5L0.40013 5.4C0.20013 5.7 0.20013 6.2 0.50013 6.5L7.20013 14.1C7.40013 14.3 7.70013 14.4 7.90013 14.4C8.20013 14.4 8.40013 14.3 8.60013 14.1L15.4001 6.5C15.8001 6.2 15.9001 5.7 15.6001 5.4ZM2.50013 5.8L3.60013 4L5.60013 6H2.70013L2.50013 5.8ZM5.40013 3H10.6001L8.00013 5.6L5.40013 3ZM12.4001 4L13.5001 5.8L13.3001 6H10.4001L12.4001 4ZM11.5001 8L8.00013 12L4.50013 8",
    fill: "#393B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.a28ad009246598266f4f5d8ae841bf56.svg";
export { ForwardRef as ReactComponent };